import React, { useLayoutEffect, useRef } from 'react';
import clsx from 'clsx';
export function SelectCellFormatter(_ref) {
  var value = _ref.value,
      tabIndex = _ref.tabIndex,
      isCellSelected = _ref.isCellSelected,
      disabled = _ref.disabled,
      onChange = _ref.onChange,
      ariaLabel = _ref['aria-label'],
      ariaLabelledBy = _ref['aria-labelledby'];
  var inputRef = useRef(null);
  useLayoutEffect(function () {
    var _inputRef$current;

    if (!isCellSelected) return;
    (_inputRef$current = inputRef.current) === null || _inputRef$current === void 0 ? void 0 : _inputRef$current.focus();
  }, [isCellSelected]);

  function handleChange(e) {
    onChange(e.target.checked, e.nativeEvent.shiftKey);
  }

  return /*#__PURE__*/React.createElement("label", {
    className: clsx('rdg-checkbox-label', {
      'rdg-checkbox-label-disabled': disabled
    })
  }, /*#__PURE__*/React.createElement("input", {
    "aria-label": ariaLabel,
    "aria-labelledby": ariaLabelledBy,
    tabIndex: tabIndex,
    ref: inputRef,
    type: "checkbox",
    className: "rdg-checkbox-input",
    disabled: disabled,
    onChange: handleChange,
    checked: value
  }), /*#__PURE__*/React.createElement("div", {
    className: "rdg-checkbox"
  }));
}